import { render, staticRenderFns } from "./DataTableCustom.vue?vue&type=template&id=43f46cbc&scoped=true&"
import script from "./DataTableCustom.vue?vue&type=script&lang=js&"
export * from "./DataTableCustom.vue?vue&type=script&lang=js&"
import style0 from "./DataTableCustom.vue?vue&type=style&index=0&id=43f46cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f46cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCheckbox,
  VDataTable,
  VDialog,
  VIcon,
  VSelect,
})
